<template>
  <!--弹窗-->
  <el-dialog width="560px" :title="title" :visible.sync="visible" :before-close="handleClose">
    <el-form  ref="formData" :model="formData" label-width="80px" size="small" style="position: relative;">
        <el-form-item label="">
            <el-upload
                class="upload-demo"
                drag
                action="/"
                accept="image/png, image/jpeg"
                :http-request="httpRequest"
                :show-file-list="false">
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                <div class="el-upload__text" style="font-size: 12px;">只能上传.png/.jpg文件</div>
            </el-upload>
        </el-form-item>
    </el-form>
    <el-row style="margin-top:17px; ">
        <el-button style="float:right" size="mini" @click="handleClose">关闭</el-button>
    </el-row>
  </el-dialog>
</template>
<script>
export default {
    data() {
        return {
            loading: false
        };
    },
    props: {
        formData: {
            type: Object,
            default: () => {}
        },
        visible: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            default: ""
        }
    },
    methods: {
        //上传图片转bese64
        httpRequest(options) {
            var that = this;
            // 获取文件对象
            let file = options.file;
            //判断图片类型
            if (
                file.type == "image/jpeg" ||
                file.type == "image/png" ||
                file.type == "image/JPG"
            ) {
                var isJPG = true;
            } else {
                isJPG = false;
            }
            // 判断图片大小
            const isLt2M = file.size / 1024 / 1024 < 2;
            if (!isJPG) {
                this.$message.error("上传图片只能是 JPG/PNG/JPEG 格式!");
                return;
            }
            if (!isLt2M) {
                this.$message.error("上传图片大小不能超过 2MB!");
                return;
            }
            // 创建一个HTML5的FileReader对象
            var reader = new FileReader();
            //创建一个img对象
            var img = new Image();
            // let filename = options.filename;
            if (file) {
                reader.readAsDataURL(file);
            }
            if (isJPG && isLt2M) {
                reader.onload = e => {
                    // let base64Str = reader.result.split(",")[1];
                    img.src = e.target.result;
                    // base64地址图片加载完毕后执行
                    img.onload = function() {
                        // 缩放图片需要的canvas（也可以在DOM中直接定义canvas标签，这样就能把压缩完的图片不转base64也能直接显示出来）
                        var canvas = document.createElement("canvas");
                        var context = canvas.getContext("2d");
                        // 图片原始尺寸
                        var originWidth = this.width;
                        var originHeight = this.height;
                        // 目标尺寸
                        var targetWidth = originWidth,
                            targetHeight = originHeight;
                        //对图片进行缩放
                        canvas.width = targetWidth;
                        canvas.height = targetHeight;
                        // 清除画布
                        context.clearRect(0, 0, targetWidth, targetHeight);
                        // 图片压缩
                        context.drawImage(img, 0, 0, targetWidth, targetHeight);
                        var newUrl = canvas.toDataURL("image/jpeg", 0.92);
                        that.formData.image = newUrl;
                        that.handleClose();
                    };
                };
            }
        },
        // 关闭弹窗
        handleClose() {
            this.loading = false;
            this.$emit("close-callback");
        }
    }
};
</script>

<style type="text/scss" lang="scss" scoped>
</style>
